import React from "react";
import { IconUser } from "@tabler/icons-react";
import styles from "../../../styles/MobileNumberLogin.module.css";

// images
import LoginMobileNumberImg from "../../../assets/images/login-mobile-number-img.png";
import LegionLogo from "../../../assets/images/legion-logo.png";
import ContactUsModalImage from "../../../assets/images/contact-us-modal-image.png";

// legion
import {
  Flex,
  Button,
  Text,
  Anchor,
  Textfield,
  Image,
  Modal,
} from "@legion-ui/core";

// hooks
import { useUsernameForgotPassword } from "../../../hooks/useUsernameForgotPassword";

export const UsernameForgotPassword = () => {
  const { showModal, state, handleInput, handleSubmit, handleBackToSignIn } =
    useUsernameForgotPassword();

  return (
    <Flex width="100%" height="100%">
      <Modal show={showModal} width="528px">
        <Image
          width="146px"
          src={ContactUsModalImage}
          alt="modal letter image"
          margin="auto"
        />

        <Text
          as="p"
          size="24px"
          color="tertiary900"
          margin="10px 0 8px 0"
          weight="700"
          style={{ textAlign: "center" }}
        >
          Message has been sent
        </Text>

        <Text
          as="p"
          color="tertiary500"
          margin="0 0 24px 0"
          style={{ textAlign: "center" }}
        >
          Thank you for contacting us and we will immediately respond to your
          message as fast as possible.
        </Text>

        <Button block center variant="solid" onClick={handleBackToSignIn}>
          Back to Sign In
        </Button>
      </Modal>

      <Flex
        alignY="center"
        alignX="center"
        padding={["5rem 0", "26px 16px"]}
        width={["", "50%"]}
        className={styles.login__form}
      >
        <Flex
          direction="column"
          style={{ maxWidth: "464px", height: "min-content" }}
          mq={{
            padding: {
              md: "2rem 1rem",
            },
          }}
        >
          <Anchor href="/" block>
            <Image
              width="146px"
              margin="0 0 32px 0"
              src={LegionLogo}
              alt="legion logo"
            />
          </Anchor>
          <Text
            as="h3"
            size={["36px", "24px"]}
            weight="700"
            margin="0 0 12px 0"
            color="tertiary900"
          >
            Forgot Password
          </Text>
          <Text
            as="p"
            size={["16px", "14px"]}
            weight="400"
            margin="0 0 24px 0"
            color="tertiary500"
          >
            In case you forgot your password, we can assist you to get it back!
          </Text>

          <Textfield
            iconLeft={<IconUser size={20} />}
            label="Username or Email Address"
            placeholder="Username / name@mail.com"
            type="email"
            status={state.status}
            message={state.error}
            onChange={handleInput}
            padding="0 0 1.5rem 0"
          />

          <Button margin="1.5rem 0 1.5rem 0" center onClick={handleSubmit}>
            Send Request
          </Button>

          <Button variant="soft" center onClick={handleBackToSignIn}>
            Back to Sign In
          </Button>

          <div style={{ textAlign: "center" }}>
            <Text margin="2rem 0 2.5rem 0 " as="p" color="tertiary500">
              Don't have an account?{" "}
              <Anchor href="/register/username" weight="700" color="primary500">
                Sign Up
              </Anchor>
            </Text>
            <Text as="p" color="tertiary500">
              &#9432; Have issue, trouble or question about login or register
            </Text>
            <Anchor href="/contact-us/username" weight="700" color="primary500">
              Contact Us
            </Anchor>
          </div>
        </Flex>
      </Flex>

      <Flex alignX="end" className={styles.login__image} width={["", "50%"]}>
        <Image
          width="auto"
          height="100%"
          src={LoginMobileNumberImg}
          fit="cover"
          alt="login mobile number as primary key image"
        />
      </Flex>
    </Flex>
  );
};
